import { SyntAudioMIcon } from "components/elements/icons/SyntAudioMIcon";

import React, { MouseEvent, useState } from "react";
import { Button, Modal } from "antd";
import { useAudioHandlesContext } from "hooks/useAudioHandlesContext";
import { useAudio } from "./hooks/useAudio";
import { useAudioStateContext } from "hooks/useAudioStateContext";
import { ILang } from "providers/AudioProvider/types";
import { IVoiceType } from "types";
import { AudioBox } from "./AudioBox/AudioBox";
import { IconContainerSC } from "./styled";

interface IAudioManageProps {
    lang: ILang;
    subtitleId: string;
    disabled: boolean;
    voice?: IVoiceType;
    currentSpeed?: number;
}

export const AudioManage: React.FC<IAudioManageProps> = ({
    lang,
    subtitleId,
    voice: currentVoice,
    disabled,
    currentSpeed,
}) => {
    const handles = useAudioHandlesContext();
    const state = useAudioStateContext();
    const [voice, setVoice] = useState<IVoiceType>(currentVoice || "male");
    const [speed, setSpeed] = useState<number>(() => currentSpeed || 1);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const { deleteAudio, saveAudio } = useAudio({
        handles,
        subtitleId,
        lang,
        folder: state.folder,
        mediaId: state.mediaId,
        useCheckedVoiceoverSynthesis: state.useCheckedVoiceoverSynthesis,
    });

    const showModal = (e: MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) {
            return;
        }
        setOpen(true);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    // Окно закрывается и кнопка отпускается при любом исходе: отказ сервера провайдер показывает
    // в полосе ошибок над дорожками. Раньше исключение проверенной озвучки оставляло «Save»
    // крутиться вечно.
    const handleSaveAudio = async () => {
        if (disabled) {
            return;
        }
        setLoading(true);
        try {
            // Голос в окне выбрал человек, только если сменил его; тот же голос — переозвучка, не выбор.
            await saveAudio(voice, speed, undefined, voice !== (currentVoice || "male"));
        } finally {
            setLoading(false);
            setOpen(false);
        }
    };

    const handleSaveOriginalAudio = async () => {
        if (disabled) {
            return;
        }
        setLoading(true);
        try {
            await saveAudio(voice, speed, "original_ru");
        } finally {
            setLoading(false);
            setOpen(false);
        }
    };

    const handleDeleteAudio = async () => {
        setLoading(true);
        const data = await deleteAudio();
        setLoading(false);
        setOpen(false);
    };

    const displaySpeed = speed !== 1 ? speed.toFixed(2).replace(/0$/, "").replace(/\.$/, "") : null;

    return (
        <>
            <IconContainerSC>
                <div style={{ position: "relative" }}>
                    <SyntAudioMIcon fontSize={"1.3em"} onClick={showModal} />
                    {displaySpeed && (
                        <span
                            style={{
                                position: "absolute",
                                bottom: -6,
                                left: "50%",
                                transform: "translateX(-50%)",
                                fontSize: 9,
                                fontWeight: 700,
                                color: "#1677ff",
                                whiteSpace: "nowrap",
                                lineHeight: 1,
                                pointerEvents: "none",
                            }}
                        >
                            {displaySpeed}x
                        </span>
                    )}
                </div>
            </IconContainerSC>
            <Modal
                open={open}
                title="Edit"
                onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel}>
                        Return
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={handleSaveAudio}>
                        Save
                    </Button>,
                    <Button key="original_ru" loading={loading} onClick={handleSaveOriginalAudio}
                        style={{ background: '#52c41a', borderColor: '#52c41a', color: '#fff' }}>
                        Original RU
                    </Button>,
                    <Button key="link" color="danger" variant="solid" onClick={handleDeleteAudio}>
                        Delete
                    </Button>,
                ]}
            >
                <AudioBox voice={voice} setVoice={setVoice} speed={speed} setSpeed={setSpeed} />
            </Modal>
        </>
    );
};
